import React, { Component } from 'react';
import './Painting.css';
import QuoteForm from '../QuoteForm/QuoteForm';
import StyleCard from '../StyleCards/StyleCard';
import slidingPatio from '../../Assets/windowStyles/slidingPatio.jpg';
import frenchDoor from '../../Assets/windowStyles/frenchDoor.png';
import { BrowserRouter as Router, Routes,Route } from 'react-router-dom';


class Painting extends Component {
  render() {
  return (
    <div class='doorMain'>
      <div class='paintingHeader'>
        <h1 class="doorTitle">
          Painting
        </h1>
      </div>
      <div class="visionSect">
         <h2>Painting</h2>
         <div class="vision">
          Our Vision at DNS Home Exteriors has always been to set a new standard of excellence for contractors that raises the bar when it comes to first-class customer service, industry knowledge, and craftsmanship.
         </div>
      </div>
      <hr></hr>
      <div class="doorInfoSect">
        <section class="doorInfo">
          <div>
          <h4>It's time to refresh the Paint</h4>
          <p>Repainting your house is one of the most effective ways to maintain and
           protect your home’s exterior and interior surfaces. Over time, paint can
           fade, crack, or peel due to weather exposure, moisture, and everyday wear
           and tear. A fresh coat of paint acts as a protective barrier against elements
            like rain, UV rays, and pests, helping to prevent wood rot, mold growth,
            and other structural issues that can arise from prolonged exposure.
          <br></br>
          <br></br>
    Beyond protection, repainting your house dramatically enhances its
    appearance and overall value. Whether you're preparing to sell or
    simply want to refresh your living space, a new paint job can modernize
    outdated colors, reflect current design trends, and make your home feel
    cleaner and more inviting. For interiors, a new color scheme can even
    improve mood and functionality in different rooms, making repainting a
    cost-effective way to rejuvenate your home’s look and feel.</p>
          </div>
        </section>
        <section class="quotoForm">
          <QuoteForm />
        </section>
      </div>
      <div class="sectionSpacer">
      </div>

  </div>
  )
};
}

export default Painting;
